import { InvoiceStatusEnum } from '@fora-monorepo/employer-my-pages-common/types';

import { TypedTFunction } from '../../i18n/i18n';

export const getStatusExplanationText = (status: InvoiceStatusEnum | null, t: TypedTFunction): string => {
  switch (status) {
    case InvoiceStatusEnum.Reminded:
      return t('status.invoiceReminded.description');
    case InvoiceStatusEnum.DebtCollection:
      return t('status.invoiceDebtCollection.description');
    case InvoiceStatusEnum.Disputed:
      return t('status.invoiceDisputed.description');
    case InvoiceStatusEnum.PaymentDeferral:
      return t('status.invoicePaymentDeferral.description');
    case InvoiceStatusEnum.InstallmentPlan:
      return t('status.invoiceInstallmentPlan.description');
    default:
      return '';
  }
};
